var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScriptDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 2H10V3H9V9.5C9 9.64 8.95167 9.75833 8.855 9.855C8.75833 9.95167 8.64 10 8.5 10H1.5C1.36 10 1.24167 9.95167 1.145 9.855C1.04833 9.75833 1 9.64 1 9.5V3H0V2H2.5V0.5C2.5 0.36 2.54833 0.241667 2.645 0.145C2.74167 0.0483332 2.86 0 3 0H7C7.14 0 7.25833 0.0483332 7.355 0.145C7.45167 0.241667 7.5 0.36 7.5 0.5V2ZM8 3H2V9H8V3ZM3.5 4.5H4.5V7.5H3.5V4.5ZM5.5 4.5H6.5V7.5H5.5V4.5ZM3.5 1V2H6.5V1H3.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScriptDeleteIcon);
export default __webpack_public_path__ + "static/media/ScriptDeleteIcon.b0b14d2292f665c2b13f4f4fec2bf31c.svg";
export { ForwardRef as ReactComponent };